import { getLangDir } from '@tesla/design-system';
import cx from 'classnames';
import React from 'react';
import { useId } from '../hooks/use-id.js';
export const Tab = ({ children, className, id, text, onChange, selected = false, targetPanelId, ...rest }) => {
    const uId = useId();
    const htmlId = id || uId;
    const handleKeyPress = (e) => {
        const dir = getLangDir(e.target);
        if ((dir === 'rtl' && e.key === 'ArrowLeft') ||
            (dir === 'ltr' && e.key === 'ArrowRight') ||
            e.key === 'ArrowDown') {
            selectTargetSibling(e.target, 'nextSibling');
        }
        if ((dir === 'rtl' && e.key === 'ArrowRight') ||
            (dir === 'ltr' && e.key === 'ArrowLeft') ||
            e.key === 'ArrowUp') {
            selectTargetSibling(e.target, 'previousSibling');
        }
    };
    const selectTargetSibling = (target, siblingKey) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore siblingKey is tricky to type
        const targetTab = target[siblingKey];
        if (targetTab) {
            targetTab.focus();
        }
    };
    return (React.createElement("button", { "aria-controls": targetPanelId, "aria-selected": selected, className: cx('tds-tab', className), id: htmlId, 
        // Note: In some browsers onFocus fires on both focus and click events.
        // To avoid duplicate calls to onChange we simply pass along the click event to focus
        // to standardize on the more keyboard-friendly pattern:
        // https://zellwk.com/blog/inconsistent-button-behavior/
        onClick: (e) => {
            e.target.focus();
        }, onFocus: onChange, onKeyDown: handleKeyPress, role: "tab", tabIndex: selected ? 0 : -1, type: "button", ...rest }, text || children));
};
